import { ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IExam, IExaminationReviewer } from 'src/app/interface/dto';
import { examDefault } from 'src/app/interface/dtoDefaults';
import { EventService } from 'src/app/services/event-services/error-event.service';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';

@Component({
  selector: 'app-add-reviewer',
  templateUrl: './add-reviewer.component.html',
  styleUrls: ['./add-reviewer.component.scss']
})
export class AddReviewerComponent implements OnInit, OnChanges {

  examinationReviewer: IExaminationReviewer = {
    examinationID: 0,
    user: '',
    id: 0
  };

  @Input() selectedReviewer: IExaminationReviewer = {} as IExaminationReviewer;

  exam: IExam = examDefault;
  users: any[] = [];
  text = 'Add';

  constructor(
    private examService: ExamService,
    private snackBar: SnackbarService,
    private cdr: ChangeDetectorRef,
    private evnt: EventService
  ) { }

  async ngOnInit() {
    this.exam = this.examService.selectedExams[0];
    this.examinationReviewer.examinationID = this.exam.id;

    this.examService.getUsers().then((res: any) => {
      if (res) {
        this.users = res.data;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['selectedReviewer']?.currentValue) {
      this.examinationReviewer = { ...changes['selectedReviewer'].currentValue };

      this.text = this.examinationReviewer.id && this.examinationReviewer.id !== 0
        ? 'Update'
        : 'Add';
    }

    this.cdr.detectChanges();
  }

  addReviewer() {
    this.examinationReviewer = {
      examinationID: this.exam.id,
      user: '',
      id: 0
    };
    this.text = 'Add';
  }

  async saveReviewer() {
    try {
      await this.examService.saveExaminationReviewer(this.examinationReviewer);

      this.snackBar.success('Reviewer saved successfully');

      this.addReviewer(); // reset form

      this.evnt.addExaminerMessageEvent.emit('refreshReviewer');

    } catch (error) {
      this.snackBar.error('Failed to save reviewer: ' + error);
    }
  }
}
